// The pre-visit brief's backend calls (backend/api/previsit_brief_views.py).
// authedFetch carries the caller's token and throws Error(payload.error) on a
// non-2xx answer — e.g. the 503 that names the migration when it is not applied.
import { authedFetch } from "./orderPaperwork";

export const fetchVisitBrief = ({ schema, visitId }) =>
  authedFetch(
    `clinic/visit-brief/?schema=${encodeURIComponent(schema || "public")}` +
      `&visit_id=${encodeURIComponent(visitId)}`,
    { method: "GET" },
  );

export const requestVisitBrief = ({ schema, visitId, trigger = "manual" }) =>
  authedFetch("clinic/visit-brief/generate/", {
    body: { schema: schema || "public", visit_id: visitId, trigger },
  });

// Asks the server to file the visit's READY brief in the caller's AI Chat thread as a pinned
// exchange, once per brief, and FIRST to take out of that thread any brief filed for another
// patient than the visit holds now (the front desk can re-point a visit, and the chat thread is
// keyed by the visit). It is worth calling on every open of the chat, brief or no brief.
// `chatPatientId` is the id the chat files its exchanges under (the chart's route param), which
// must be the visit's own id or chart number. Every answer carries `removed_ids`, the chat
// exchanges it deleted; the rest is one of
//   {attached: true, feedback_id, prompt, response, created_at}     a new exchange,
//   {attached: false, feedback_id, prompt, response, created_at}    the thread already holds it
//                                                     (so a retry after a lost answer can show it),
//   {attached: false, reason: "not_ready" | "stale"}                nothing to file.
export const attachVisitBriefToChat = ({ schema, visitId, chatPatientId, threadId = 1 }) =>
  authedFetch("clinic/visit-brief/chat/", {
    body: {
      schema: schema || "public",
      visit_id: visitId,
      chat_patient_id: chatPatientId,
      thread_id: threadId,
    },
  });
